import { render, staticRenderFns } from "./forgetpass.vue?vue&type=template&id=1bc94d21&scoped=true"
import script from "./forgetpass.vue?vue&type=script&lang=js"
export * from "./forgetpass.vue?vue&type=script&lang=js"
import style0 from "./forgetpass.vue?vue&type=style&index=0&id=1bc94d21&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc94d21",
  null
  
)

export default component.exports